import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'api/login',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: 'api/register',
    method: 'post',
    data
  })
}

export function validateCode(data) {
  return request({
    url: 'api/validateCode',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: 'api/logout',
    method: 'post'
  })
}
